import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesComponent } from './services.component';
import { MassTransferEditorComponent } from './mass-transfer-editor/mass-transfer-editor.component';
import { SharedModule } from '../../../shared/shared.module';
import { UIModule } from '../../ui/ui.module';
import { JvUiModule } from '../../../../../projects/jv-ui/src/lib/jv-ui.module';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MassTransferResolverComponent } from './mass-transfer-resolver/mass-transfer-resolver.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIModule,
    JvUiModule,
    SelectDropDownModule
  ],
  declarations: [
    ServicesComponent,
    MassTransferEditorComponent,
    MassTransferResolverComponent
  ],
  entryComponents: [
    MassTransferEditorComponent,
    MassTransferResolverComponent
  ]
})
export class ServicesModule { }
